<template>
  <va-edit-layout :title="title">
    <categories-form :id="id" :item="item" />
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
